module.exports = __webpack_public_path__ + "static/covid-922b29a1d00bf6b65ac4301ebcdcdb9a.png";